import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Unmatched Payments</h1>
            <p className="mb-0">List of unmatched payments</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/unmatchedPayment/view-header.js